<template>
    <main class="mt-5">
        <div class="card mt-3">
            <div class="card-header  border-0 justify-content-between d-flex">
                <h5 class="card-title font-bold py-3">مدیریت فروش فروشندگان</h5>
                <div style="flex: 1"></div>
                <router-link to="/admin/sales-management/reports/result-goods/" class="btn btn-secondary ml-5">
                    گزارشات
                    <i class="fe fe-bar-chart-2"></i>
                </router-link>
            </div>
            <div class="card-body">
                <div class="row flex-row justify-content-start mb-3 g-3">

                    <div class="col-auto" v-for="seller in sellers">
                        <div class="report-item-card">
                            <span class="report-label">{{seller.full_name}}</span>
                            <router-link
                                type="button"
                                :to="`/admin/sales-management/change-status/${(seller&&seller.id)?seller.id:''}?
                                    type=return&seller_name=${(seller&&seller.full_name)?seller.full_name:''}`"
                                class="btn btn-danger"
                                style="background-color: #bb3e52eb !important;"
                                >بازگشت تنوع
                            </router-link>
                            <router-link
                                type="button"
                                :to="'/admin/sales-management/' + seller.id"
                                class="btn btn-dark"
                                >مشاهده جزئیات
                                <span class="bg-dot">{{ seller.pending_seller_requests_count }}</span>
                            </router-link>
                        </div>
                    </div>
                </div>
                <Loading v-if="$root.isEmptyObject(sellers)" />
            </div>
        </div>
    </main>
</template>

<script>
import SalesManagementImpl from "@@/core/pages/SalesManagement/SalesManagementList/SalesManagementImpl";
export default {
    extends: SalesManagementImpl,
};
</script>
<style src="@@/core/pages/SalesManagement/SalesManagementList/SalesManagementStyle.css" scoped></style>